module.exports = __webpack_public_path__ + "static/media/wheel.02af25d9.png";